// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'development',
  apiUrl: 'https://demoapi.ezyhire.com/api/ep1',
  nodeApi: 'https://demo-tp-api.ezyhire.com/api',
  appUrl: 'https://demo-candidate.ezyhire.com',
  apiTimeout: 30000,
  enableLogging: true,
  enableDebugMode: true,
  version: '1.0.0',
  idv: {
    apiUrl: 'https://demo-api.incodesmile.com',
    apiKey: 'dc5ebf598c31bdbfb830e3e77bcadd8fe36fd9a3',
    flowId: '65f08139ac19b78faadbad4c',
    consentId: '67189481effde133e1116722',
    idvUrl: 'https://demo-onboarding.incodesmile.com/ezyhire138/flow/65f08139ac19b78faadbad4c'
  },
  ui: {
    theme: 'light',
    language: 'en',
    showDevTools: true
  }
}; 